// @ts-nocheck

export const localeCodes =  [
  "en",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_c75ef6ec",
      load: () => import("#nuxt-i18n/c75ef6ec" /* webpackChunkName: "locale_en_46json_c75ef6ec" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_9b1854b6",
      load: () => import("#nuxt-i18n/9b1854b6" /* webpackChunkName: "locale_es_46json_9b1854b6" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: undefined
  },
  {
    code: "es",
    language: undefined
  }
]

